import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X, ShoppingBag } from 'lucide-react';
const NAMES = ['Martín G.', 'Rodrigo P.', 'Luciana M.', 'Joaquín D.', 'Sebastián R.', 'Federico A.', 'Carolina V.', 'Diego H.', 'Mariano L.', 'Andrés F.', 'Gonzalo S.', 'Lucas B.', 'Pablo C.', 'Nicolás O.', 'Tomás E.', 'Matías J.', 'Agustín R.', 'Emiliano P.', 'Hernán T.', 'Cristian U.', 'Leandro M.', 'Facundo Q.', 'Iván K.', 'Damián N.', 'Esteban Z.', 'Brian I.', 'Walter Y.', 'Maximiliano D.', 'Franco V.', 'Daniela A.', 'Soledad B.', 'Verónica C.', 'Romina F.', 'Florencia G.', 'Natalia H.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Corrientes', 'Bariloche', 'Río Cuarto', 'Comodoro Rivadavia', 'San Luis', 'Paraná', 'Formosa', 'Jujuy', 'La Rioja', 'Santiago del Estero', 'Catamarca', 'Tandil', 'Olavarría', 'Concordia', 'Villa María', 'Pergamino'];
const OFFERS = ['el Megapack Básquet Resuelto', 'el Megapack Básquet Resuelto PRO'];
interface Purchase {
  name: string;
  city: string;
  offer: string;
  timeAgo: string;
}
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function generatePurchase(): Purchase {
  const minutes = Math.floor(Math.random() * 10) + 1;
  return {
    name: pick(NAMES),
    city: pick(CITIES),
    offer: pick(OFFERS),
    timeAgo: minutes === 1 ? 'hace 1 minuto' : `hace ${minutes} minutos`
  };
}
export function PurchasePopup() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setPurchase(generatePurchase());
      setVisible(true);
      // Hide after ~5 seconds
      hideTimeout = setTimeout(() => {
        setVisible(false);
        // Wait 40-60s before next show
        const nextDelay = Math.floor(Math.random() * 20000) + 40000;
        showTimeout = setTimeout(cycle, nextDelay);
      }, 5000);
    };
    // Initial delay before first popup (8-12s after page load)
    const initialDelay = Math.floor(Math.random() * 4000) + 8000;
    showTimeout = setTimeout(cycle, initialDelay);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  const handleDismiss = () => setVisible(false);
  return <AnimatePresence data-id="element-288">
      {visible && purchase && <motion.div initial={{
      opacity: 0,
      y: 30,
      x: -10
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -10
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 22
    }} className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm z-50 pointer-events-auto" role="status" aria-live="polite" data-id="element-289">
          <div className="bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden flex items-stretch" data-id="element-290">
            {/* Left accent */}
            <div className="bg-brand-orange w-2 shrink-0" data-id="element-291"></div>

            {/* Icon */}
            <div className="p-3 flex items-center justify-center shrink-0" data-id="element-292">
              <div className="w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center" data-id="element-293">
                <ShoppingBag size={18} className="text-brand-orange" data-id="element-294" />
              </div>
            </div>

            {/* Content */}
            <div className="flex-grow py-3 pr-3 min-w-0" data-id="element-295">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-296">
                <CheckCircle2 size={12} className="text-green-500 shrink-0" data-id="element-297" />
                <span className="text-[10px] font-bold text-green-600 uppercase tracking-wider" data-id="element-298">
                  Compra verificada
                </span>
              </div>
              <p className="text-xs text-brand-dark leading-snug" data-id="element-299">
                <span className="font-bold" data-id="element-300">{purchase.name}</span>
                <span className="text-gray-500" data-id="element-301"> de </span>
                <span className="font-semibold" data-id="element-302">{purchase.city}</span>
                <span className="text-gray-500" data-id="element-303"> compró </span>
                <span className="font-bold text-brand-orange" data-id="element-304">
                  {purchase.offer}
                </span>
              </p>
              <p className="text-[10px] text-gray-400 font-medium mt-0.5" data-id="element-305">
                {purchase.timeAgo}
              </p>
            </div>

            {/* Close */}
            <button onClick={handleDismiss} aria-label="Cerrar notificación" className="p-2 self-start text-gray-300 hover:text-gray-600 transition-colors shrink-0" data-id="element-306">
              <X size={14} data-id="element-307" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}